import { useState } from "react";

export default function Section10() {
    const [isOpen, setIsOpen] = useState(new Array(9).fill(false));

    const handleFaq = (index) => {
        setIsOpen((prevState) =>
            prevState.map((item, idx) => (idx === index ? !item : false))
        );
    };

    const faqs = [
        {
            question: "Why is TikTok advertising essential for businesses in Dubai and Abu Dhabi?",
            answer:
                "TikTok dominates mobile usage across the UAE, giving brands access to highly engaged, diverse audiences that traditional platforms may miss. It's crucial for rapid brand awareness, especially in fast-moving consumer sectors like retail, entertainment, and hospitality, allowing you to reach consumers where they spend their time."
        },
        {
            question: "What type of ad content works best for UAE audiences on TikTok?",
            answer:
                "Content must prioritize authenticity over high polish. Videos that perform best are:\n" +
                "- Fast-paced and entertaining, using trending local sounds and effects.\n" +
                "- Localized, often featuring familiar Dubai or Abu Dhabi landmarks and lifestyles.\n" +
                "- Educational or service-based, but presented in a casual, creator-driven format."
        },
        {
            question: "Do my TikTok ads need to be bilingual (English and Arabic) to succeed in the UAE?",
            answer:
                "Yes, bilingual capability is critical. While English is widely used, using Arabic in ad copy, subtitles, and voiceovers significantly increases trust and engagement among a large portion of the UAE's resident population. A mixed-language strategy ensures maximum market penetration."
        },
        {
            question: "How precise is the targeting available for TikTok campaigns in the Emirates?",
            answer:
                "TikTok Ads Manager allows for detailed geo-targeting, enabling you to focus campaigns specifically on cities like Dubai, Abu Dhabi, or Sharjah. You can also target based on demographics, user interests, video interaction habits, and custom audiences, ensuring your budget reaches the most relevant consumers."
        },
        {
            question: "What are the key compliance rules for TikTok ads targeting the UAE market?",
            answer:
                "Ads must strictly comply with both TikTok's global policies and specific UAE laws. This includes respecting cultural and religious sensitivities, avoiding the promotion of prohibited items, and ensuring all content adheres to local advertising standards regarding truthfulness and public decency. Pre-launch compliance checks are mandatory."
        },
        {
            question: "What’s included in your TikTok Ads Management service?",
            answer:
                "Our TikTok Ads Management includes full campaign setup, creative production, audience targeting, daily optimization, performance tracking, and reporting. We handle everything from concept to conversion so your campaigns deliver consistent results."
        },
        {
            question: "Can TikTok marketing help e-commerce stores in the UAE?",
            answer:
                "Yes, TikTok is one of the most effective platforms for e-commerce growth in the UAE. With features like TikTok Shop and direct website integration, brands can drive product discovery and conversions within a single platform."
        },
        {
            question: "Is TikTok banned in the UAE?",
            answer:
                "No, TikTok is not banned in the UAE. The platform is fully accessible to users across Dubai, Abu Dhabi, and other Emirates. However, all content and ads must comply with UAE laws and cultural guidelines. TikTok also enforces strict moderation as millions of videos are removed each year in the region for violating local or community standards. Brands and creators can freely advertise and grow on TikTok as long as their content respects UAE regulations."
        }
    ];




    return (
        <div className="w-full Section8 mt-[12%] md:mt-[4%]">
            <div className="w-full section8-container">
                <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
                    <h2 className="leading-[29px] md:leading-[41px] text-[26px] md:text-[30px] text-[#151515] font-bold my-[0.67em]">
                        Frequently Asked Questions About TikTok Marketing in the UAE
                    </h2>
                </div>

                <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
                            style={{
                                background:
                                    "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
                            }}
                        >
                            <div
                                onClick={() => handleFaq(index)}
                                className="question text-[#444444] cursor-pointer flex justify-between items-center"
                            >
                                {faq.question}
                                <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[index] ? "-" : "+"}</b>
                            </div>
                            <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444"]`}>
                                <br />
                                {faq.answer.includes("-") ? (
                                    <>
                                        {/* Intro line */}
                                        <p className="mb-2">{faq.answer.split("\n")[0]}</p>

                                        {/* Bullet points */}
                                        <ul className="list-disc pl-5 mb-5 space-y-1">
                                            {faq.answer
                                                .split("\n")
                                                .slice(1) // skip the first line
                                                .map((line, idx) => {
                                                    const trimmed = line.trim();
                                                    if (!trimmed) return null;
                                                    return <li key={idx}>{trimmed.replace(/^- /, "")}</li>;
                                                })}
                                        </ul>
                                    </>
                                ) : (
                                    <p className="mb-5">{faq.answer}</p>
                                )}
                            </div>


                        </div>
                    ))}
                </div>
            </div>

            <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
